import * as React from 'react';
import Button from 'components/Button';
import { tenantConfig } from 'utils/tenant';
import { myCameraStream } from 'state/video';
import { voipRtcConnection } from 'utils/ui/rtc';
import { classNames } from 'utils/ui/css';
import { isVoipEnabled } from 'state/session';

type TSessionControls = {
  voipActive?: boolean;
  children?: React.ReactNode;
};

const SessionControls: React.FC<TSessionControls> = ({ voipActive = false, children }) => {
  /** This component can be rendered as a part of the VOIP WC and as a child of it,
   * it would have these hooks invoked at the parent level already */
  if (!voipActive) {
    tenantConfig().useState();
    myCameraStream().useState();
  }

  const canRenderVoipButtons =
    voipActive ||
    (tenantConfig().isAllowed('voip') && myCameraStream().stream instanceof MediaStream && isVoipEnabled());

  return (
    <>
      {/* VOIP has to be enabled and stream accessible/allowed */}
      {canRenderVoipButtons && (
        <>
          <Button
            icon="ex3d-icon--camera"
            part="voip-button--camera"
            svgClassName="bg-black"
            className={classNames(
              'stream-header-icon-camera',
              myCameraStream().get('isVideoEnabled')
                ? 'ex3d-enabled ex3d-icon--state__on'
                : 'ex3d-disabled stream-header-icon-camera-disabled ex3d-icon--state__off'
            )}
            onClick={() => {
              voipRtcConnection.toggleMedia('video');
            }}
          />
          <Button
            icon="ex3d-icon--mic"
            part="voip-button--mic"
            svgClassName="bg-black"
            className={classNames(
              'stream-header-icon-mic',
              myCameraStream().get('isAudioEnabled')
                ? 'ex3d-enabled ex3d-icon--state__on'
                : 'ex3d-disabled stream-header-icon-mic-disabled ex3d-icon--state__off'
            )}
            onClick={() => {
              voipRtcConnection.toggleMedia('audio');
            }}
          />
        </>
      )}
      {children}
    </>
  );
};

export default SessionControls;
